export default {
  name: "TrusteesView",
  data() {
    return {
      trustees: [
        {
          id: 1,
          initials: "TM",
          name: "Thabo Mokoena",
          role: "Chairman",
          email: "thabo.mokoena@beetrust.co.za",
          phone: "+27 82 123 4567",
          location: "Sandton, Johannesburg",
          appointed: "15 January 2018",
        },
        {
          id: 2,
          initials: "ND",
          name: "Nomvula Dlamini",
          role: "Founder Trustee",
          email: "nomvula.dlamini@beetrust.co.za",
          phone: "+27 83 234 5678",
          location: "Rosebank, Johannesburg",
          appointed: "15 January 2018",
        },
        {
          id: 3,
          initials: "Jv",
          name: "Johan van der Merwe",
          role: "Independent Trustee",
          email: "johan.vdm@lawfirm.co.za",
          phone: "+27 84 345 6789",
          location: "Pretoria, Gauteng",
          appointed: "1 June 2019",
        },
        {
          id: 4,
          initials: "AN",
          name: "Ayanda Nkosi",
          role: "Trustee",
          email: "ayanda.nkosi@beetrust.co.za",
          phone: "+27 85 456 7890",
          location: "Umhlanga, Durban",
          appointed: "10 March 2020",
        },
        {
          id: 5,
          initials: "FP",
          name: "Fatima Patel",
          role: "Trustee",
          email: "fatima.patel@beetrust.co.za",
          phone: "+27 86 567 8901",
          location: "Cape Town, Western Cape",
          appointed: "20 September 2021",
        },
      ],
    };
  },
  methods: {
    role_badge_class(role) {
      switch (role) {
        case "Chairman":
          return "bg-light text-dark border";
        case "Founder Trustee":
          return "bg-warning-subtle text-warning border";
        case "Independent Trustee":
          return "bg-primary-subtle text-primary border";
        default:
          return "bg-secondary-subtle text-secondary border";
      }
    },
  },
};